import script from "./contactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./contactUs.vue?vue&type=script&setup=true&lang=js"

import "./contactUs.vue?vue&type=style&index=0&id=966e05c6&lang=less&scoped=true"

import exportComponent from "D:\\myProject\\qtx\\2026\\qtx-officialwebsite\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-966e05c6"]])

export default __exports__